
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import { VisitVehicle } from '../models/visit-vehicle.entity';
import { VisitVehicleService } from '../services/visit-vehicle.service';


/**
 * Visit Vehicle data source
 */
export class VisitVehicleDataSource implements DataSource<VisitVehicle> {

  /**
   * Visit Vehicle subject
   *
   * @private
   */
  private visitVehiclesSubject = new BehaviorSubject<VisitVehicle[]>([]);

  /**
   * Loading subject
   *
   * @private
   */
  private loadingSubject = new BehaviorSubject<boolean>(false);

  /**
   * Loading observable
   */
  public loading$ = this.loadingSubject.asObservable();

  /**
   * Constructor
   *
   * @param visitVehicleService  service
   */
  constructor(private visitVehicleService: VisitVehicleService) {
  }

  /**
   * Connect to collection
   *
   * @param collectionViewer CollectionViewer
   *
   * @returns Observable
   */
  connect(collectionViewer: CollectionViewer): Observable<VisitVehicle[]> {
    return this.visitVehiclesSubject.asObservable();
  }

  /**
   * Disconnect from collection
   *
   * @param collectionViewer CollectionViewer
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.visitVehiclesSubject.complete();
    this.loadingSubject.complete();
  }

  /**
   * Load data from collection
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Object with filtered attributes
   */
  load(order: string = 'visitId', sort: string = 'desc', limit: number = 10, page: number = 0, filter: object = {
      today: true
    }): void {

    this.loadingSubject.next(true);

    const options = {order, sort, limit, page};

    for (const i in filter) {
      if (filter.hasOwnProperty(i) && filter[i] === '') {
        delete filter[i];
      }
    }

    this.visitVehicleService.findFiltered({...options, ...filter}).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(visitVehicles => this.visitVehiclesSubject.next(visitVehicles));
  }
}
